/* виджеты собраны как статичная библиотека в wwwroot/static/libs/widgets.js
   при модификации желательно не затрагивать ts файлы во избежание проблем со сборкой */
// import './Shared/Infrastructure/Behaviours/Widgets/WidgetBehavior';
// import './Shared/Widgets/WidgetController';
// import './Shared/Widgets/HotEvents/HotEventsWidgetController';
// import './Shared/Widgets/Reviews/ReviewWidgetController';
// import './Shared/Widgets/Interesting/InterestingWidgetController';

import './Shared/libs/jquery/jquery-ui.min.js';
import './Shared/libs/jquery/jquery.ui.touch-punch.min.js';
import './Shared/libs/jquery/jquery.touchSwipe.min.js';
import './Shared/libs/jquery.powertip/jquery.powertip.js';
import './Shared/libs/jquery/jquery.nice-select.min.js';
import './Shared/libs/jquery.timepicker/jquery-ui-timepicker-addon.js';
import './Shared/libs/blockUI/jquery.blockUI.js';
import './Shared/libs/inputmask/inputmask.js';
import './Shared/libs/inputmask/jquery.inputmask.js';
import './Shared/libs/jquery.validate/jquery.validate.js';
import './Shared/libs/jquery.validate/jquery.validate.unobtrusive.js';
import './Shared/libs/microsoft/signalr/dist/browser/signalr.min.js';
import './Shared/Infrastructure/Localization';
import './Shared/libs/jquery/jquery-ui-datepicker-settings.js';

import './Shared/Infrastructure/LanguageSelector';
import './Shared/Infrastructure/UiBlock';
import './Shared/Infrastructure/Utils';
import './Shared/Infrastructure/Ajax';
import './Shared/Infrastructure/Popup';
import './Shared/Infrastructure/Validators';
import './Shared/Infrastructure/Behaviours/BaseControlBehaviour';
import './Shared/Infrastructure/Behaviours/AjaxActionBehavior';
import './Shared/Infrastructure/Behaviours/EnterBehaviour';
import './Shared/Infrastructure/Behaviours/AutoFocusBehaviour';
import './Shared/Infrastructure/Behaviours/DatePickerBehaviour';
import './Shared/Infrastructure/Behaviours/InputMaskBehaviour';
import './Shared/Infrastructure/Behaviours/InputTrimBehaviour';
import './Shared/Infrastructure/Behaviours/PagerBehaviour';
import './Shared/Infrastructure/Behaviours/ReplaceTagBehaviour';
import './Shared/Infrastructure/Behaviours/TooltipsBehaviour';
import './Shared/Infrastructure/Behaviours/RecaptchaBehaviour';
import './Shared/Infrastructure/Behaviours/PasswordPreviewBehaviour';
import './Shared/Infrastructure/Behaviours/SortableBehaviour';
import './Shared/Infrastructure/Behaviours/CustomSelectsBehaviour';
import './Shared/Infrastructure/Behaviours/ChangablesBehaviour';
import './Shared/Infrastructure/Behaviours/TabsBehaviour';
import './Shared/Infrastructure/Behaviours/ToggleBehaviour';
import './Shared/Infrastructure/Behaviours/Component/ComponentBehavior';
import './Shared/Infrastructure/Behaviours/ScrollbarBehaviour';
import './Shared/Infrastructure/Behaviours/PaymentChannelAmountBehaviour';
import './Shared/Infrastructure/Behaviours/VoximplantCallBehaviour';
import './Shared/Infrastructure/Behaviours/CustomFileBehaviour';
import './Shared/Infrastructure/Behaviours/FileControlsBehaviour';
import './Shared/Infrastructure/SRLiveAdapter';
import './Shared/Infrastructure/Behaviours/Reviews/UseBettingCartBehaviour';
import './Shared/Infrastructure/Behaviours/AddressesTableBehaviour';
import './Shared/Infrastructure/Controls';
import './Shared/Infrastructure/LocalStorageProvider';
import './Shared/Infrastructure/Behaviours/NotificationBehaviour';
import './Shared/Sports/Sports';
import './Shared/SignalR/SignalRConfigBuilder';
import './Shared/SignalR/SignalR';
import './Shared/startup.js';
